import { SubHeadline, Title } from '~components/Typography';

import { Container, TabButton } from './styles';

type TabItem = {
	label: React.ReactNode;
	value: string;
};

type Props = {
	className?: string;
	size?: 'S' | 'M';
	onChange?: (tab: string) => void;
	value: string;
	tabs: TabItem[];
};

export const TabMenu = ({
	className,
	tabs,
	value,
	onChange,
	size = 'M',
}: Props) => {
	return (
		<Container className={className}>
			{tabs.map((tab) => (
				<TabButton
					size={size}
					key={tab.value}
					selected={tab.value === value}
					onClick={() => onChange?.(tab.value)}
				>
					{size === 'S' && <SubHeadline size="S">{tab.label}</SubHeadline>}
					{size === 'M' && <Title size="S">{tab.label}</Title>}
				</TabButton>
			))}
		</Container>
	);
};
